import { useEffect, useState } from "react";
import ListPage from "../../components/ListPage";
import { useUI } from "../../UIContext";
import { handleErr, paginationPageSize } from "../../utils/functions";
import { useNavigate } from "react-router-dom";
import Icon from "../../components/Icon";
import { get } from "../../services/api";

function News() {
    const amountByPage = paginationPageSize();
    const page = 1;

    const { loading, setLoading, setMessage } = useUI();
    const [news, setNews] = useState([]);
    const [newsFiltered, setNewsFiltered] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [pageSize, setPageSize] = useState(amountByPage);
    const [pageTotal, setPageTotal] = useState(0);
    const navigate =  useNavigate();

    function onClickUpdateNews(newsId) {
        navigate(`/news/update/${newsId}`);
    }

    const tableCols = [
        {
            dataIndex: 'title',
            title: 'Título',
            render: (value) => (
                <span>{value}</span>
            )
        },
        {
            title: 'Ações',
            width: '120px',
            render: (_, row) => (
                <button onClick={() => onClickUpdateNews(row.id)} className='border-button edit-button glass-button-effect-15'>
                    <Icon iconClass='icon-pencil' size={16} />
                    Editar
                </button>
            )
        }
    ];

    useEffect(() => {
        async function getNews() {
            setLoading(true);

            await get('/news', true, setMessage,
                (response) => {
                    setNews(response.data);
                },
                (err) => {
                    handleErr(setMessage, `Não foi possível carregar as notícias: ${err}`);
                },
                () => {
                    setLoading(false);
                }
            )
        }

        getNews();
    }, [setLoading, setMessage]);

    useEffect(() => {
        if (!news || news.length === 0) {
            setNewsFiltered([]);
            setPageTotal(0);
            return;
        }

        const startIndex = (page - 1) * pageSize;
        const endIndex = startIndex + pageSize;

        const newsFound = news?.filter(item => 
            item.title?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
            item.description?.toLowerCase().includes(searchTerm?.toLowerCase())
        );

        setPageTotal(newsFound.length);
        setNewsFiltered(newsFound.slice(startIndex, endIndex));
    }, [searchTerm, page, pageSize, news]);

    if (loading)
        return;

    return (
        <ListPage
            title='Gestão de Notícias'
            addButtonTitle='Nova notícia'
            onClickAddButton={() => navigate('/news/create')}
            onChangeSearch={(e) => setSearchTerm(e.target.value)}
            tableCols={tableCols}
            dataFiltered={newsFiltered}
            tablePageTotal={pageTotal}
            onChangeTablePage={() => { setPageSize(pageSize + amountByPage) }}
        />
    );
}

export default News;